import { Summary } from '../models/summary.interfaces';

export const SummaryMocks: Summary = {
  header: 'SkyMiles Overview',
  label: '38,000',
  title: 'MILES AVAILABLE',
  description: 'Use these miles for Award Travel and other redemptions.',
  action: {
    id: 'skymilesLandingPageSummaryBookWithMiles',
    label: 'BOOK WITH MILES',
    link: '/flight-search/book-a-flight?action=searchFlights&tripType=ROUND_TRIP&awardTravel=true&paxCount=1'
  },
  disabled: false,
  loaded: true
};
